module.exports = __webpack_public_path__ + "static/media/role.b30d4149.png";